import { render } from "./SortCategoryProduct.vue?vue&type=template&id=35c3c9d6&ts=true"
import script from "./SortCategoryProduct.vue?vue&type=script&lang=ts"
export * from "./SortCategoryProduct.vue?vue&type=script&lang=ts"

import "./SortCategoryProduct.vue?vue&type=style&index=0&id=35c3c9d6&lang=css"

import exportComponent from "D:\\YellowBeardProject\\keisi\\keisishopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__